import script from "./UCMultiSearchEntitySelector.vue?vue&type=script&setup=true&lang=js"
export * from "./UCMultiSearchEntitySelector.vue?vue&type=script&setup=true&lang=js"

import "./UCMultiSearchEntitySelector.vue?vue&type=style&index=0&id=448ffafd&lang=scss"

const __exports__ = script;

export default __exports__